import * as React from "react";
const SvgVideo = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M19.181 10.4L8.274 2.40401C6.925 1.41501 5 2.35601 5 4.00401V19.996C5 21.644 6.925 22.585 8.274 21.596L19.181 13.6C20.273 12.8 20.273 11.2 19.181 10.4Z",
	fill: "#909294"
}));
export default SvgVideo;
